import { useState, useEffect } from 'react';
import {
  Autocomplete,
  TextField,
  InputAdornment,
  CircularProgress,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const GEOCODER =
  // 'https://maps.victoriatx.org/arcgis/rest/services/CompositeLocator/GeocodeServer';
  'https://maps.victoriatx.gov/arcgis/rest/services/PublishedServices/CompositeLocator/GeocodeServer';
// const SEARCH_EXTENT = {
//   xmin: -97.0928,
//   ymin: 28.9452,
//   xmax: -96.8374,
//   ymax: 28.7085,
//   spatialReference: { wkid: 4326, latestWkid: 4326 },
// };

export default function AddressSearch({
  onAddressFound,
  fetchingData,
  onSearchTextCleared,
}) {
  const [selectedAddress, setSelectedAddress] = useState('');
  const [searchTextInput, setSearchTextInput] = useState('');
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAddressOptions = () => {
      if (searchTextInput && searchTextInput.length > 3) {
        setLoading(true);
        fetch(`${GEOCODER}/suggest?text=${searchTextInput}&f=pjson`)
          .then((response) => {
            console.log('response:');
            console.log(response);
            return response.json();
          })
          .then((data) => {
            console.log('data:');
            console.log(data);
            setOptions(data.suggestions);
            setLoading(false);
          })
          .catch((err) => {
            console.log('error:');
            console.log(err);
            setOptions([{ text: 'Error looking up address' }]);
            setLoading(false);
          });
      }
    };
    getAddressOptions();
  }, [searchTextInput]);

  useEffect(() => {
    console.log('selectedAddress:');
    console.log(selectedAddress);
    if (selectedAddress) {
      // &magicKey=${selectedAddress.magicKey}
      fetch(
        `${GEOCODER}/findAddressCandidates?SingleLine=${encodeURI(
          selectedAddress.text,
        )}&outSR=4326&f=json`,
      )
        .then((response) => response.json())
        .then((data) => {
          console.log('selectedAddress data:');
          console.log(data);

          onAddressFound(data?.candidates?.[0]);
        })
        .catch((err) => {
          console.log('geocoding error:', err);
        });
    }
  }, [selectedAddress]);

  useEffect(() => {
    if (searchTextInput.length === 0) {
      onSearchTextCleared();
    }
  }, [searchTextInput]);

  return (
    <>
      <Autocomplete
        sx={{
          margin: 0,
        }}
        fullWidth
        autoComplete
        freeSolo
        options={options}
        loading={loading}
        filterOptions={(x) => x}
        getOptionLabel={(option) => (option.text ? option.text : '')}
        // getOptionSelect={(option, value) => option.name === value.name}
        onChange={(event, newValue) => setSelectedAddress(newValue)}
        onInputChange={(event, newInputValue) =>
          setSearchTextInput(newInputValue)
        }
        renderInput={(params) => (
          <TextField
            fullWidth
            {...params}
            placeholder='Enter Address'
            variant='outlined'
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  {fetchingData ? <CircularProgress /> : <SearchIcon />}
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </>
  );
}
